import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  Card,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";
import { useDispatch, useSelector } from "react-redux";
import { partnerListTable as tableDef } from "../../../config/grid-columns-defs";
import {
  createPartner,
  getFinalAgreement,
  getPartnersDropdownList,
  getPartnerSignedAgreement,
  getPartnersList,
  postUploadFinalAgreement,
} from "../../../api/partnerList";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import {
  CloudUpload,
  Download,
  DownloadOutlined,
  Upload,
  UploadFile,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { makeStyles } from "@material-ui/core";
import { Downloader } from "ag-grid-community";
import BetterControlledTable from "../../../component/BetterControlledTable";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function PartnerList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  let partnerSignedAgreement = tableDef.find(
    (o) => o.headerName === "Partner Signed Agreement"
  );
  let uploadFinalAgreement = tableDef.find(
    (o) => o.headerName === "Upload Final Agreement"
  );
  let finalAgreement = tableDef.find((o) => o.headerName === "Final Agreement");
  const [itemDialogOpen, setItemDialogOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [partnerName, setPartnerName] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [itemDialog, setItemDialog] = useState(false);
  const [uploadId, setUploadId] = useState("");
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  addAdditionalColumn(obj, dispatch);
  addAdditionalColumnPartnerSignedAgreement(partnerSignedAgreement, dispatch);
  addAdditionalColumnUploadFinalAgreement(uploadFinalAgreement, dispatch);
  addAdditionalColumnFinalAgreement(finalAgreement, dispatch);

  function addAdditionalColumnPartnerSignedAgreement(partnerSignedAgreement) {
    if (partnerSignedAgreement === undefined) {
      tableDef.push({
        headerName: "Partner Signed Agreement",
        field: "partner_signed_agreement",
        minWidth: 200,
        resizable: true,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRendererFramework: (params) => (
          <IconButton
            color="info"
            onClick={() => {
              if (params.data.uploadedbypartner === "") {
                dispatch(
                  showAlert("Partner signed document is not uploaded yet !!")
                );
              } else {
                getPartnerSignedAgreementDownloadData(params.data.id);
              }
            }}
          >
            <Download fontSize="inherit" />
          </IconButton>
        ),
        // cellStyle: { fontSize: "11px", color: "blue" },
        // onCellClicked: (params) => {
        //   getPartnerSignedAgreementDownloadData(params.data.id);
        // },
      });
    }
  }
  function addAdditionalColumnFinalAgreement(finalAgreement) {
    if (finalAgreement === undefined) {
      tableDef.push({
        headerName: "Final Agreement",
        field: "final_agreement",
        minWidth: 160,
        headerClass: "justify-center",
        cellClass: "justify-center",
        resizable: true,
        cellRendererFramework: (params) => (
          <IconButton
            color="info"
            onClick={() => {
              if (
                params.data.uploadedbyadmin === "" ||
                params.data.uploadedbyadmin === null
              ) {
                dispatch(
                  showAlert("Final Agreement by admin is not uploaded yet !!")
                );
              } else {
                getFinalAgreementDownloadData(params.data.id);
              }
            }}
          >
            <Download fontSize="inherit" />
          </IconButton>
        ),
        // cellStyle: { fontSize: "11px", color: "blue" },
        // onCellClicked: (params) => {
        //   getFinalAgreementDownloadData(params.data.id);
        // },
      });
    }
  }
  function addAdditionalColumnUploadFinalAgreement(uploadFinalAgreement) {
    if (uploadFinalAgreement === undefined)
      tableDef.push({
        headerName: "Upload Final Agreement",
        field: "upload_final_agreement",
        minWidth: 200,
        headerClass: "justify-center",
        cellClass: "justify-center",
        resizable: true,
        cellRendererFramework: (params) => (
          <IconButton
            color="info"
            onClick={() => {
              if (params.data.uploadedbypartner === "") {
                dispatch(
                  showAlert("Partner signed document is not uploaded yet !!")
                );
              } else {
                setUploadId(params.data.id);
                setItemDialog(true);
              }
            }}
          >
            <Upload fontSize="inherit" />
          </IconButton>
        ),
        // cellStyle: { fontSize: "11px", color: "blue" },
        // onCellClicked: (params) => {
        //   setUploadId(params.data.id);
        //   setItemDialog(true);
        //   // onUploadDocument(params.data.id);
        // },
      });
  }

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);
  useEffect(() => {
    refreshTable();
  }, [partnerName]);
  function refreshTable(e) {
    e?.preventDefault();
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getRows(limit, offset) {
    try {
      const { data } = await getPartnersList(
        { partnername: partnerName, limit, offset },
        user.token
      );

      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  const getPartnerSignedAgreementDownloadData = (id) => {
    const token = user.token;

    getPartnerSignedAgreement(id, token)
      .then((blob) => {
        // const file = window.URL.createObjectURL(blob.data);

        // window.open(file, "_blank");
        // Extract filename from header
        // console.log(response["headers"]); // Full information

        // const filename = blob.headers
        //   .get("content-disposition")
        //   .split(";")
        //   .find((n) => n.includes("filename="))
        //   .replace("filename=", "")
        //   .trim();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `partner${id}_termscondition.pdf`);
        document.body.appendChild(link);
        link.click();
        refreshTable();
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const getFinalAgreementDownloadData = (id) => {
    const token = user.token;
    getFinalAgreement(id, token)
      .then((blob) => {
        // const file = window.URL.createObjectURL(blob.data);

        // window.open(file, "_blank");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute(
          "download",
          `VerifiedbyAdmin_partner${id}_termscondition.pdf`
        );
        document.body.appendChild(link);
        link.click();
        refreshTable();
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Partners
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Partner
        </Button>
      </Box>
      <br />
      <Box className="pmt-filter-box">
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item md={2} sm={4} xs={12}>
            <TextField
              className={classes.textfeild}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={partnerName}
              label="Partner Name"
              fullWidth
              size="small"
              onChange={(e) => {
                setPartnerName(e.target.value);
              }}
            />
          </Grid>
          <Grid item md={10} xs={8}></Grid>
        </Grid>
      </Box>
      <div className="pmt-controll-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getRows}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </div>
      {/* <ControlledTable
        rows={rows}
        columnDefs={tableDef}
        getRows={getRows}
        totalCount={totalCount}
        onChange={setRows}
        onPageNumberChange={setPageNumber}
        pageSize={10}
        pageNumber={pageNumber}
        pagination={true}
        hasActionButtons={false}
      /> */}
      <AddPartnerDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
        disableEscapeKeyDown
      />
      <ItemDialogDocumentUploadTab
        open={itemDialog}
        setOpen={setItemDialog}
        id={uploadId}
        refreshTable={refreshTable}
        setItemDialogOpen={setItemDialogOpen} //
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth: 70,
      resizable: true,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEW", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }
}

const emptyNewPartnerData = {
  name: "",
  email: "",
  password: "",
  contact: "",
  address: "",
  city: "",
  state: "",
  country: "",
  role: "",
};
function AddPartnerDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewPartnerData);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewPartnerData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewPartnerData);
    }
  }, [open]);

  async function onNewPartnerSubmit(data) {
    const addData = {
      // role: "Partner",
      agreement_status: "pending",
    };
    const newData = { ...data, ...addData };
    try {
      const { data } = await createPartner(newData, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen(true);
      }}
    >
      <DialogTitle>Create New Partner</DialogTitle>
      <Box component="form" onSubmit={onNewPartnerSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="name"
                label="Name"
                required
                fullWidth
                inputRef={register({
                  required: "Name is required.",
                })}
                error={Boolean(errors.name)}
                helperText={errors.name?.message}
                className="name-textfeild"
              />
            </Grid>

            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="email"
                label="Email"
                required
                fullWidth
                inputRef={register({
                  required: "Email Address  is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="password"
                label="Password"
                required
                fullWidth
                inputRef={register({
                  required: "Password is required.",
                })}
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
                type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                InputProps={{
                  // <-- This is where the toggle button is added.
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="contact"
                label="Contact"
                required
                fullWidth
                type="tel"
                inputProps={{ maxLength: 10 }}
                inputRef={register({
                  required: "Contact Number is required.",
                  validate: (value) =>
                    value.length > 9 || "Please enter a valid number",
                })}
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="address"
                label="Address"
                required
                fullWidth
                inputRef={register({
                  required: "Address is required.",
                })}
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth required error={Boolean(errors.country)}>
                <InputLabel id="demo-simple-select-label-a">Country</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={props.onChange}
                      //className="select-box-height"
                      MenuProps={{ className: "select-box-height" }}
                    >
                      {CountryCodes.map((data, key) => (
                        <MenuItem key={key} value={data.country}>
                          {data.country}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="country"
                  label="Country"
                  control={control}
                  rules={{
                    required: "Please select Country Name",
                  }}
                />
                <FormHelperText>{errors.country?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="state"
                label="State"
                required
                fullWidth
                inputRef={register({
                  required: "State Name is required.",
                })}
                error={Boolean(errors.state)}
                helperText={errors.state?.message}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="city"
                label="City"
                required
                fullWidth
                inputRef={register({
                  required: "City Name is required.",
                })}
                error={Boolean(errors.city)}
                helperText={errors.city?.message}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="role"
                label="Role"
                required
                fullWidth
                inputRef={register({
                  required: "Role is required.",
                })}
                error={Boolean(errors.role)}
                helperText={errors.role?.message}
              />
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            className="blue-button"
            onClick={handleSubmit(onNewPartnerSubmit)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function ItemDialogDocumentUploadTab({
  open,
  setOpen,
  id,
  refreshTable,
  setItemDialogOpen,
}) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const [itemDialog, setItemDialog] = useState(false);
  const onUploadDocument = async (formData) => {
    try {
      const { data } = await postUploadFinalAgreement(formData, id, user.token);
      setOpen(false);
      setLoader(false);
      setIsSelected(false);
      setSelectedFile("");
      dispatch(showAlert(data.msg));

      // Close the dialog after the agreement is uploaded
      setItemDialogOpen(false);

      // Call the refreshTable callback to refresh the table data
      refreshTable();
    } catch (error) {
      console.log(error);
      setOpen(false);
      setLoader(false);
      handleAxiosError(error, dispatch);
    }
  };

  const submit = () => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("ATTACHMENTS_TAB");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    formData.append("myFile", selectedFile);
    setLoader(true);
    onUploadDocument(formData);
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Upload Document
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModifiedDate:{" "}
                          {selectedFile.lastModifiedDate.toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button disabled={loader} className="blue-button" onClick={submit}>
          {"Submit"}
        </Button>

        {loader && (
          <Box sx={{ ml: 1 }}>
            <CircularProgress />
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
}
const CountryCodes = [
  { country: "Afghanistan", code: "93", iso: "AF" },
  { country: "Albania", code: "355", iso: "AL" },
  { country: "Algeria", code: "213", iso: "DZ" },
  { country: "American Samoa", code: "1-684", iso: "AS" },
  { country: "Andorra", code: "376", iso: "AD" },
  { country: "Angola", code: "244", iso: "AO" },
  { country: "Anguilla", code: "1-264", iso: "AI" },
  { country: "Antarctica", code: "672", iso: "AQ" },
  { country: "Antigua and Barbuda", code: "1-268", iso: "AG" },
  { country: "Argentina", code: "54", iso: "AR" },
  { country: "Armenia", code: "374", iso: "AM" },
  { country: "Aruba", code: "297", iso: "AW" },
  { country: "Australia", code: "61", iso: "AU" },
  { country: "Austria", code: "43", iso: "AT" },
  { country: "Azerbaijan", code: "994", iso: "AZ" },
  { country: "Bahamas", code: "1-242", iso: "BS" },
  { country: "Bahrain", code: "973", iso: "BH" },
  { country: "Bangladesh", code: "880", iso: "BD" },
  { country: "Barbados", code: "1-246", iso: "BB" },
  { country: "Belarus", code: "375", iso: "BY" },
  { country: "Belgium", code: "32", iso: "BE" },
  { country: "Belize", code: "501", iso: "BZ" },
  { country: "Benin", code: "229", iso: "BJ" },
  { country: "Bermuda", code: "1-441", iso: "BM" },
  { country: "Bhutan", code: "975", iso: "BT" },
  { country: "Bolivia", code: "591", iso: "BO" },
  { country: "Bosnia and Herzegovina", code: "387", iso: "BA" },
  { country: "Botswana", code: "267", iso: "BW" },
  { country: "Brazil", code: "55", iso: "BR" },
  { country: "British Indian Ocean Territory", code: "246", iso: "IO" },
  { country: "British Virgin Islands", code: "1-284", iso: "VG" },
  { country: "Brunei", code: "673", iso: "BN" },
  { country: "Bulgaria", code: "359", iso: "BG" },
  { country: "Burkina Faso", code: "226", iso: "BF" },
  { country: "Burundi", code: "257", iso: "BI" },
  { country: "Cambodia", code: "855", iso: "KH" },
  { country: "Cameroon", code: "237", iso: "CM" },
  { country: "Canada", code: "1", iso: "CA" },
  { country: "Cape Verde", code: "238", iso: "CV" },
  { country: "Cayman Islands", code: "1-345", iso: "KY" },
  { country: "Central African Republic", code: "236", iso: "CF" },
  { country: "Chad", code: "235", iso: "TD" },
  { country: "Chile", code: "56", iso: "CL" },
  { country: "China", code: "86", iso: "CN" },
  { country: "Christmas Island", code: "61", iso: "CX" },
  { country: "Cocos Islands", code: "61", iso: "CC" },
  { country: "Colombia", code: "57", iso: "CO" },
  { country: "Comoros", code: "269", iso: "KM" },
  { country: "Cook Islands", code: "682", iso: "CK" },
  { country: "Costa Rica", code: "506", iso: "CR" },
  { country: "Croatia", code: "385", iso: "HR" },
  { country: "Cuba", code: "53", iso: "CU" },
  { country: "Curacao", code: "599", iso: "CW" },
  { country: "Cyprus", code: "357", iso: "CY" },
  { country: "Czech Republic", code: "420", iso: "CZ" },
  { country: "Democratic Republic of the Congo", code: "243", iso: "CD" },
  { country: "Denmark", code: "45", iso: "DK" },
  { country: "Djibouti", code: "253", iso: "DJ" },
  { country: "Dominica", code: "1-767", iso: "DM" },
  { country: "Dominican Republic", code: "1-809, 1-829, 1-849", iso: "DO" },
  { country: "East Timor", code: "670", iso: "TL" },
  { country: "Ecuador", code: "593", iso: "EC" },
  { country: "Egypt", code: "20", iso: "EG" },
  { country: "El Salvador", code: "503", iso: "SV" },
  { country: "Equatorial Guinea", code: "240", iso: "GQ" },
  { country: "Eritrea", code: "291", iso: "ER" },
  { country: "Estonia", code: "372", iso: "EE" },
  { country: "Ethiopia", code: "251", iso: "ET" },
  { country: "Falkland Islands", code: "500", iso: "FK" },
  { country: "Faroe Islands", code: "298", iso: "FO" },
  { country: "Fiji", code: "679", iso: "FJ" },
  { country: "Finland", code: "358", iso: "FI" },
  { country: "France", code: "33", iso: "FR" },
  { country: "French Polynesia", code: "689", iso: "PF" },
  { country: "Gabon", code: "241", iso: "GA" },
  { country: "Gambia", code: "220", iso: "GM" },
  { country: "Georgia", code: "995", iso: "GE" },
  { country: "Germany", code: "49", iso: "DE" },
  { country: "Ghana", code: "233", iso: "GH" },
  { country: "Gibraltar", code: "350", iso: "GI" },
  { country: "Greece", code: "30", iso: "GR" },
  { country: "Greenland", code: "299", iso: "GL" },
  { country: "Grenada", code: "1-473", iso: "GD" },
  { country: "Guam", code: "1-671", iso: "GU" },
  { country: "Guatemala", code: "502", iso: "GT" },
  { country: "Guernsey", code: "44-1481", iso: "GG" },
  { country: "Guinea", code: "224", iso: "GN" },
  { country: "Guinea-Bissau", code: "245", iso: "GW" },
  { country: "Guyana", code: "592", iso: "GY" },
  { country: "Haiti", code: "509", iso: "HT" },
  { country: "Honduras", code: "504", iso: "HN" },
  { country: "Hong Kong", code: "852", iso: "HK" },
  { country: "Hungary", code: "36", iso: "HU" },
  { country: "Iceland", code: "354", iso: "IS" },
  { country: "India", code: "91", iso: "IN" },
  { country: "Indonesia", code: "62", iso: "ID" },
  { country: "Iran", code: "98", iso: "IR" },
  { country: "Iraq", code: "964", iso: "IQ" },
  { country: "Ireland", code: "353", iso: "IE" },
  { country: "Isle of Man", code: "44-1624", iso: "IM" },
  { country: "Israel", code: "972", iso: "IL" },
  { country: "Italy", code: "39", iso: "IT" },
  { country: "Ivory Coast", code: "225", iso: "CI" },
  { country: "Jamaica", code: "1-876", iso: "JM" },
  { country: "Japan", code: "81", iso: "JP" },
  { country: "Jersey", code: "44-1534", iso: "JE" },
  { country: "Jordan", code: "962", iso: "JO" },
  { country: "Kazakhstan", code: "7", iso: "KZ" },
  { country: "Kenya", code: "254", iso: "KE" },
  { country: "Kiribati", code: "686", iso: "KI" },
  { country: "Kosovo", code: "383", iso: "XK" },
  { country: "Kuwait", code: "965", iso: "KW" },
  { country: "Kyrgyzstan", code: "996", iso: "KG" },
  { country: "Laos", code: "856", iso: "LA" },
  { country: "Latvia", code: "371", iso: "LV" },
  { country: "Lebanon", code: "961", iso: "LB" },
  { country: "Lesotho", code: "266", iso: "LS" },
  { country: "Liberia", code: "231", iso: "LR" },
  { country: "Libya", code: "218", iso: "LY" },
  { country: "Liechtenstein", code: "423", iso: "LI" },
  { country: "Lithuania", code: "370", iso: "LT" },
  { country: "Luxembourg", code: "352", iso: "LU" },
  { country: "Macao", code: "853", iso: "MO" },
  { country: "Macedonia", code: "389", iso: "MK" },
  { country: "Madagascar", code: "261", iso: "MG" },
  { country: "Malawi", code: "265", iso: "MW" },
  { country: "Malaysia", code: "60", iso: "MY" },
  { country: "Maldives", code: "960", iso: "MV" },
  { country: "Mali", code: "223", iso: "ML" },
  { country: "Malta", code: "356", iso: "MT" },
  { country: "Marshall Islands", code: "692", iso: "MH" },
  { country: "Mauritania", code: "222", iso: "MR" },
  { country: "Mauritius", code: "230", iso: "MU" },
  { country: "Mayotte", code: "262", iso: "YT" },
  { country: "Mexico", code: "52", iso: "MX" },
  { country: "Micronesia", code: "691", iso: "FM" },
  { country: "Moldova", code: "373", iso: "MD" },
  { country: "Monaco", code: "377", iso: "MC" },
  { country: "Mongolia", code: "976", iso: "MN" },
  { country: "Montenegro", code: "382", iso: "ME" },
  { country: "Montserrat", code: "1-664", iso: "MS" },
  { country: "Morocco", code: "212", iso: "MA" },
  { country: "Mozambique", code: "258", iso: "MZ" },
  { country: "Myanmar", code: "95", iso: "MM" },
  { country: "Namibia", code: "264", iso: "NA" },
  { country: "Nauru", code: "674", iso: "NR" },
  { country: "Nepal", code: "977", iso: "NP" },
  { country: "Netherlands", code: "31", iso: "NL" },
  { country: "Netherlands Antilles", code: "599", iso: "AN" },
  { country: "New Caledonia", code: "687", iso: "NC" },
  { country: "New Zealand", code: "64", iso: "NZ" },
  { country: "Nicaragua", code: "505", iso: "NI" },
  { country: "Niger", code: "227", iso: "NE" },
  { country: "Nigeria", code: "234", iso: "NG" },
  { country: "Niue", code: "683", iso: "NU" },
  { country: "North Korea", code: "850", iso: "KP" },
  { country: "Northern Mariana Islands", code: "1-670", iso: "MP" },
  { country: "Norway", code: "47", iso: "NO" },
  { country: "Oman", code: "968", iso: "OM" },
  { country: "Pakistan", code: "92", iso: "PK" },
  { country: "Palau", code: "680", iso: "PW" },
  { country: "Palestine", code: "970", iso: "PS" },
  { country: "Panama", code: "507", iso: "PA" },
  { country: "Papua New Guinea", code: "675", iso: "PG" },
  { country: "Paraguay", code: "595", iso: "PY" },
  { country: "Peru", code: "51", iso: "PE" },
  { country: "Philippines", code: "63", iso: "PH" },
  { country: "Pitcairn", code: "64", iso: "PN" },
  { country: "Poland", code: "48", iso: "PL" },
  { country: "Portugal", code: "351", iso: "PT" },
  { country: "Puerto Rico", code: "1-787, 1-939", iso: "PR" },
  { country: "Qatar", code: "974", iso: "QA" },
  { country: "Republic of the Congo", code: "242", iso: "CG" },
  { country: "Reunion", code: "262", iso: "RE" },
  { country: "Romania", code: "40", iso: "RO" },
  { country: "Russia", code: "7", iso: "RU" },
  { country: "Rwanda", code: "250", iso: "RW" },
  { country: "Saint Barthelemy", code: "590", iso: "BL" },
  { country: "Saint Helena", code: "290", iso: "SH" },
  { country: "Saint Kitts and Nevis", code: "1-869", iso: "KN" },
  { country: "Saint Lucia", code: "1-758", iso: "LC" },
  { country: "Saint Martin", code: "590", iso: "MF" },
  { country: "Saint Pierre and Miquelon", code: "508", iso: "PM" },
  { country: "Saint Vincent and the Grenadines", code: "1-784", iso: "VC" },
  { country: "Samoa", code: "685", iso: "WS" },
  { country: "San Marino", code: "378", iso: "SM" },
  { country: "Sao Tome and Principe", code: "239", iso: "ST" },
  { country: "Saudi Arabia", code: "966", iso: "SA" },
  { country: "Senegal", code: "221", iso: "SN" },
  { country: "Serbia", code: "381", iso: "RS" },
  { country: "Seychelles", code: "248", iso: "SC" },
  { country: "Sierra Leone", code: "232", iso: "SL" },
  { country: "Singapore", code: "65", iso: "SG" },
  { country: "Sint Maarten", code: "1-721", iso: "SX" },
  { country: "Slovakia", code: "421", iso: "SK" },
  { country: "Slovenia", code: "386", iso: "SI" },
  { country: "Solomon Islands", code: "677", iso: "SB" },
  { country: "Somalia", code: "252", iso: "SO" },
  { country: "South Africa", code: "27", iso: "ZA" },
  { country: "South Korea", code: "82", iso: "KR" },
  { country: "South Sudan", code: "211", iso: "SS" },
  { country: "Spain", code: "34", iso: "ES" },
  { country: "Sri Lanka", code: "94", iso: "LK" },
  { country: "Sudan", code: "249", iso: "SD" },
  { country: "Suriname", code: "597", iso: "SR" },
  { country: "Svalbard and Jan Mayen", code: "47", iso: "SJ" },
  { country: "Swaziland", code: "268", iso: "SZ" },
  { country: "Sweden", code: "46", iso: "SE" },
  { country: "Switzerland", code: "41", iso: "CH" },
  { country: "Syria", code: "963", iso: "SY" },
  { country: "Taiwan", code: "886", iso: "TW" },
  { country: "Tajikistan", code: "992", iso: "TJ" },
  { country: "Tanzania", code: "255", iso: "TZ" },
  { country: "Thailand", code: "66", iso: "TH" },
  { country: "Togo", code: "228", iso: "TG" },
  { country: "Tokelau", code: "690", iso: "TK" },
  { country: "Tonga", code: "676", iso: "TO" },
  { country: "Trinidad and Tobago", code: "1-868", iso: "TT" },
  { country: "Tunisia", code: "216", iso: "TN" },
  { country: "Turkey", code: "90", iso: "TR" },
  { country: "Turkmenistan", code: "993", iso: "TM" },
  { country: "Turks and Caicos Islands", code: "1-649", iso: "TC" },
  { country: "Tuvalu", code: "688", iso: "TV" },
  { country: "U.S. Virgin Islands", code: "1-340", iso: "VI" },
  { country: "Uganda", code: "256", iso: "UG" },
  { country: "Ukraine", code: "380", iso: "UA" },
  { country: "United Arab Emirates", code: "971", iso: "AE" },
  { country: "United Kingdom", code: "44", iso: "GB" },
  { country: "United States", code: "1", iso: "US" },
  { country: "Uruguay", code: "598", iso: "UY" },
  { country: "Uzbekistan", code: "998", iso: "UZ" },
  { country: "Vanuatu", code: "678", iso: "VU" },
  { country: "Vatican", code: "379", iso: "VA" },
  { country: "Venezuela", code: "58", iso: "VE" },
  { country: "Vietnam", code: "84", iso: "VN" },
  { country: "Wallis and Futuna", code: "681", iso: "WF" },
  { country: "Western Sahara", code: "212", iso: "EH" },
  { country: "Yemen", code: "967", iso: "YE" },
  { country: "Zambia", code: "260", iso: "ZM" },
  { country: "Zimbabwe", code: "263", iso: "ZW" },
];
